import React from 'react';

import { EventRepository } from '~/repositories';

import { EventsTable } from './Events';

export const PageWebhookEvents: React.FC = () => (
  <EventsTable
    tableId="webhookEvents"
    fetchEvents={EventRepository.getAllWebhooks}
    emptyTitle="No webhook events found"
  />
);
